import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		account: null,
		profile: null,
		todos: [],
		session: null,
		response: null,
		results: null,
		text: null,
	},
	getters: {
		account: state => state.account,
		profile: state => state.profile,
		todos: state => state.todos,
		session: state => state.session,
		sessions: state => state.sessions,
		response: state => state.response,
		results: state => state.results,
		text: state => state.text,
	},
	mutations: {
		SET_ACCOUNT(state, payload) {
			state.account = payload || null
		},
		SET_PROFILE(state, payload) {
			state.profile = payload || null
		},
		SET_SESSIONS(state, payload) {
			state.sessions = payload || null
		},
		SET_SESSION(state, payload) {
			state.session = payload || null
		},
		SET_RESPONSE(state, payload) {
			state.response = payload || null
		},
		SET_RESULTS(state, payload) {
			state.results = payload || null
		},
		SET_TEXT(state, payload) {
			state.text = payload || null
		},
	},
	actions: {
		setAccount({commit}, payload) {
			commit('SET_ACCOUNT', payload)
		},
		setText({commit}, payload) {
			commit('SET_TEXT', payload)
		},

		setProfile({commit}, payload) {
			commit('SET_PROFILE', payload)
		},
		setSessions({commit}, payload) {
			commit('SET_SESSIONS', payload)
		},
		setSession({commit}, payload) {
			commit('SET_SESSION', payload)
		},

		setResponse({commit}, payload) {
			commit('SET_RESPONSE', payload)
		},

		setResults({commit}, payload) {
			commit('SET_RESULTS', payload)
		},
	},
})
